import { useQuery } from '@tanstack/react-query';
import {
  getRequisitions, type RequisitionFilters 
} from '../api';

export function useRequisitions(siteId: string, filters?: RequisitionFilters) {
  return useQuery({
    queryKey: ['requisitions', siteId, filters],
    queryFn: () => getRequisitions(siteId, filters),
    enabled: Boolean(siteId),
    staleTime: 30_000,
  });
}
